import React, { useState } from 'react';
import './PhoneCall.css';

const PhonePreJoin = ({ isHost, roomInfo, roomAlias, meetingCode, joining, audioEnabled, videoEnabled, setAudioEnabled, setVideoEnabled, joinError, onJoin, displayName, setDisplayName, password, setPassword, guestEmail, setGuestEmail, guestPhone, setGuestPhone, notifyStatus, handleNotifyHost, wantsHostAlert, handleHostAlertToggle, browserPermission, notifyGuestsStatus, handleNotifyGuests, onLeaveHostMode }) => {
  const callerName = isHost ? (roomInfo?.room_name || 'Your Room') : (roomInfo?.meeting_name || 'Meeting');
  const initials = callerName.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase() || '?';
  const [linkCopied, setLinkCopied] = useState(false);

  return (
    <div className="phone-call phone-call--prejoin">
      <div className="phone-call-top">
        <h1 className="phone-call-name">
          {callerName}
          {isHost && <span className="phone-call-host-badge">HOST</span>}
        </h1>
        <p className="phone-call-status">
          {isHost ? 'Waiting for guests' : roomInfo?.host_status === 'in_room' ? 'Host is in the room' : roomInfo?.host_status === 'waiting' ? 'Host is in the waiting room' : 'Host is not here yet'}
        </p>
        <p className="phone-call-room-sub">
          {roomInfo?.room_name} · {roomInfo?.meeting_name}
        </p>
        {isHost && (
          <div style={{display:'flex',gap:8,justifyContent:'center',marginTop:6}}>
            <a href="/linktime" className="phone-call-back-rooms">← Back to rooms</a>
            <button className="phone-call-back-rooms" onClick={() => {
              var url = window.location.origin + '/link/' + roomAlias + '/' + meetingCode + '?force_guest=1';
              navigator.clipboard.writeText(url);
              setLinkCopied(true);
              setTimeout(function() { setLinkCopied(false); }, 2000);
            }} style={{border:'none',cursor:'pointer',background:'none',fontSize:12,color:'#4498A2'}}>{linkCopied ? '✓ Copied!' : '📋 Copy invite link'}</button>
          </div>
        )}
      </div>

      <div className="phone-call-spacer">
        <div className="phone-call-avatar">{initials}</div>
        {!isHost && roomInfo?.host_status === 'offline' && (
          <div className="phone-call-waiting">
            Waiting for host
            <span className="phone-call-waiting-dots"><span /><span /><span /></span>
          </div>
        )}

        {/* Guest: name + email */}
        {!isHost && (
          <div className="phone-call-guest-fields">
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Your name"
              className="phone-call-input"
            />
            <input
              type="email"
              value={guestEmail}
              onChange={(e) => setGuestEmail(e.target.value)}
              placeholder="Email (optional)"
              className="phone-call-input"
            />
            <input
              type="tel"
              value={guestPhone}
              onChange={(e) => setGuestPhone(e.target.value)}
              placeholder="Phone (SMS when host arrives)"
              className="phone-call-input"
            />
          </div>
        )}

        {/* Host: waiting guests */}
        {isHost && roomInfo?.waiting_guests && roomInfo.waiting_guests.length > 0 && (
          <div className="phone-call-guests">
            <div className="phone-call-guests-title">{roomInfo.waiting_guests.length} waiting</div>
            {roomInfo.waiting_guests.filter(function(g, i, arr) { 
              var name = typeof g === 'string' ? g : (g.name || g.email || 'Guest');
              return arr.findIndex(function(x) { var xn = typeof x === 'string' ? x : (x.name || x.email || 'Guest'); return xn === name; }) === i;
            }).map(function(g, idx) { 
              var name = typeof g === 'string' ? g : (g.name || g.email || 'Guest');
              return <div key={name} className="phone-call-guest-pill">{name}</div>;
            })}
          </div>
        )}
      </div>

      {joinError && (
        <div className="phone-call-join-error">{joinError}</div>
      )}

      {/* Password */}
      {roomInfo?.requires_password && (
        <div className="phone-call-password-row">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Room password"
            required
            className="phone-call-input"
          />
        </div>
      )}

      <div className="phone-call-controls">
        <button className={`phone-call-ctrl mute ${!audioEnabled ? 'on' : ''}`} onClick={() => setAudioEnabled(!audioEnabled)}>
          {!audioEnabled ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="1" y1="1" x2="23" y2="23"/><path d="M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6"/><path d="M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
            </svg>
          )}
        </button>

        <button className="phone-call-ctrl join" onClick={onJoin} disabled={joining}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 9c-1.6 0-3.15.25-4.6.72v2.54c0 .24-.14.46-.37.54l-2.9 1.17a1.5 1.5 0 00-.93 1.47v1.9c0 .46.39.83.85.75 2.8-.5 5.6-.5 8.4 0 .46.08.85-.29.85-.75v-1.9c0-.64-.41-1.21-1.02-1.42l-2.59-1.04a.58.58 0 01-.37-.54v-2.63C10.6 9.19 10.34 9 10 9h4z"/>
          </svg>
        </button>

        <button className={`phone-call-ctrl camera ${videoEnabled ? 'on' : ''}`} onClick={() => setVideoEnabled(!videoEnabled)}>
          {videoEnabled ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M15 10l4.55-3.4A1 1 0 0121 7.4v9.2a1 1 0 01-1.45.9L15 14v-4z"/><rect x="3" y="6" width="12" height="12" rx="2"/></svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="1" y1="1" x2="23" y2="23"/><path d="M15 10l4.55-3.4A1 1 0 0121 7.4v9.2a1 1 0 01-1.45.9L15 14v-4z"/><rect x="3" y="6" width="12" height="12" rx="2"/></svg>
          )}
        </button>
      </div>

      {/* Guest: notify + browser alert (compact, below controls) */}
      {!isHost && !roomInfo?.host_online && (
        <div className="phone-call-notify-bar">
          <label className="phone-call-notify-check">
            <input type="checkbox" checked={wantsHostAlert} onChange={(e) => handleHostAlertToggle(e.target.checked)} disabled={browserPermission === 'unsupported'} />
            Alert me
          </label>
          <button className="phone-call-notify-btn" onClick={() => handleNotifyHost(false)} disabled={notifyStatus === 'sending'}>
            {notifyStatus === 'sending' ? '...' : notifyStatus === 'sent' ? 'Sent!' : 'Ping host'}
          </button>
        </div>
      )}

      {/* Host: notify guests + leave host mode */}
      {isHost && (
        <div className="phone-call-notify-bar">
          {roomInfo?.waiting_guests && roomInfo.waiting_guests.length > 0 && (
            <button className="phone-call-notify-btn" onClick={handleNotifyGuests} disabled={notifyGuestsStatus === 'sending'}>
              {notifyGuestsStatus === 'sending' ? '...' : notifyGuestsStatus === 'sent' ? 'Sent!' : 'Notify guests'}
            </button>
          )}
          <button className="phone-call-notify-btn" onClick={onLeaveHostMode}>Leave host mode</button>
        </div>
      )}

      <div className="phone-call-copyright">© 2017-2026 NumFree</div>
    </div>
  );
};

export default PhonePreJoin;
